exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n[data-v-672bf43f]:export {\n  xrColorPrimary: #2362FB;\n}\n.wk-form[data-v-672bf43f] .el-form-item.is-product {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 100%;\n          flex: 0 0 100%;\n}\n", ""]);

// exports
